import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import constants from "../../common/constants";
import _ from "lodash";

import * as RoutingSelectors from "modules/routing/routing-selectors";
import { FormattedMessage } from "react-intl";

import Logo from "./self-diagnosis-logo";

import "styles/index.css";
import { stringEndsWith } from "../utils/text-utils";

class SelfDiagnosticFinished extends Component {
  static propTypes = {
    onNext: PropTypes.func.isRequired,
    routeParams: PropTypes.object,
    brand: PropTypes.object
  };

  getMyTreatmentObj() {
    let { treatment } = this.props.routeParams;

    if (!treatment) return constants.diagnosisColouringRules.default;

    treatment = treatment.toLowerCase();
    return (
      _.find(constants.diagnosisColouringRules, function(item) {
        return stringEndsWith(treatment, item.key);
      }) || constants.diagnosisColouringRules.default
    );
  }

  render() {
    const treatmentObj = this.getMyTreatmentObj();

    return (
      <div className="Guidance l-container">
        {/*uncomment for testing 
        <LocaleSwitcher passedClass="absolute" />*/}
        <div className="modal diagnosis-finished">
          <div className="consent-wrapper">
            <div className="title">
              <FormattedMessage id={treatmentObj.title} />
            </div>
            {treatmentObj.key && (
              <div className="logo">
                <Logo colour={treatmentObj.colour} />
              </div>
            )}
          </div>
          <div className="consent-text">
            <p className="plain-text">
              <FormattedMessage
                id={treatmentObj.text}
                values={{
                  break: (
                    <em>
                      <br /> <br />
                    </em>
                  )
                }}
              />
            </p>
            <p className="extended-text">
              <FormattedMessage
                id={treatmentObj.textExtended}
                values={{
                  break: (
                    <em>
                      <br /> <br />
                    </em>
                  )
                }}
              />
            </p>
          </div>
          <div className="next diagnosis-finished-button">
            <button className="Button--round" onClick={this.props.onNext}>
              <FormattedMessage id="diagnosis_finished.proceed" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  routeName: RoutingSelectors.getCurrentRouteName(state),
  routeParams: RoutingSelectors.getCurrentRouteParams(state)
});

export default connect(mapStateToProps)(SelfDiagnosticFinished);



// WEBPACK FOOTER //
// ./src/modules/general-info/self-diagnostic-finished.js